<template>
  <section class="landing-workable">

    <div class="inner-container">

      <h2 class="section-title">
        Nossas vagas
      </h2>

      <ul class="jobs-list">
        <li class=" jobs-item" v-for="job in jobs">
          <h3>
            {{job.title}}
          </h3>
          <round-button :href="job.url" target="_blank" class="show-job">
            Inscreva-se
          </round-button>
        </li>
      </ul>
    </div>
  
  </section>  
</template>

<style lang="less">
  @import (reference) '../assets/styles/references';
  @gradient-light-gray: #8890A8;
  @gradient-dark-gray: #3B4E5B;
  .landing-workable{
    background: linear-gradient(-45deg, @gradient-light-gray, @gradient-dark-gray);
    padding: @xs-spacer 0 (@md-spacer + @xs-spacer);
    border-radius: @xs-spacer/2;
    margin: @sm-spacer;
    .section-title{
      color: @white;
    }
    .inner-container{
      overflow: hidden;
    }
    .show-job{
      display: block;
      text-align: center;
      padding: 0 20px;
      span{
        font-size: 16px;
      }
    }
    .show-job {
      width: 150px;
      position: absolute;
      bottom: -10px;
      left: 50%;
      transform: translate(-50%, 0) !important;
    }

  }
  .jobs-list{
    list-style: none;
    float: left;
    display: flex;
    flex-wrap: wrap;
    
    h3{
      width: 100%;
      font-size: 22px;
      font-weight: @font-weight-bold;
      color: @dark-blue;
      text-overflow: ellipsis;
      overflow: hidden;
      line-height: 1em;
      text-transform: uppercase;
    }
    
    .jobs-rating{
      font-size: 24px;
    }
    .moip-icon-code-fork {
      color: #09BFD9;
    }
    .moip-icon-star {
      color: @yellow;
    }

    .jobs-item{
      position: relative;
      display: flex;
      align-items: center;
      // height: 190px;
      width: 280px;
      background-color: @white;
      border-radius: @xs-spacer/2;
      margin: @sm-spacer @xs-spacer;
      float: left;
      box-sizing: border-box;
      padding: @xs-spacer @sm-spacer @md-spacer;
    }
  }
</style>

<script>
  import RoundButton from './RoundButton'

  export default {

    data() {
      return {
        jobs: []
      }
    },
    components: {
      RoundButton
    },
    mounted: function() {
      let workableAPI = 'static/workable-mock.json'
      this.$http.get(workableAPI).then((response) => {
        console.log(response);
        this.jobs = response.body.jobs
      }, (errorResponse) => {
        console.error(errorResponse)
      });
    }
  }
</script>



// WEBPACK FOOTER //
// LandingWorkable.vue?18298d43